





























































































import Vue from 'vue'
import firebase from 'firebase/app'
import 'firebase/auth'
import { user } from '../fire'
import router from '../router/index'
import * as Interface from '../../functions/interfaces'


export default Vue.extend({
    mounted() {
        if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
            this.login()
        }


        // Monitor email change
        // Changing the email may ask the user to log out and log in again, so I don't want to change it if I don't have to
        firebase.auth().onAuthStateChanged((u) => {
            this.originalEmail = u?.email
        })
    },


    data() {
        return {
            user: user,
            email: '' as string,
            loading: false,
            message: undefined as string | undefined,
            originalEmail: undefined as string | null | undefined,
            router: router,
            agreed: false
        }
    },


    methods: {
        request_link: async function() {

            // Validate
            if (this.email == '' || this.email == undefined) return


            // Config
            this.loading = true
            const settings = {
                url: window.location.href,
                handleCodeInApp: true
            }


            // Process
            localStorage.setItem('auth', JSON.stringify(this.email))
            firebase.auth().languageCode = this.$i18n.locale            
            try { 
                await firebase.auth().sendSignInLinkToEmail(this.email, settings) 
                this.message = this.$t('login_email_sent')
            }
            catch(error) { alert(error) }
            finally { this.loading = false }
        },


        login: async function() {

            // Config
            this.loading = true
            let email = localStorage.getItem('auth') as string
            email = email.split('"').join('')
        

            // Process
            try {
                await firebase.auth().signInWithEmailLink(email, window.location.href) 
                localStorage.removeItem('auth')
                console.log('Auth 👍')
                window.history.pushState(null, document.title, location.href.split('?')[0])
            }
            catch(error) { alert(error) }
            finally { this.loading = false }
        },


        validate(): string | undefined {
            function test(value: string | undefined): boolean {
                return value != undefined && value != ''
            }

            if (!test(user.first_name)) return 'Hiányzó keresztnév'
            if (!test(user.last_name)) return 'Hiányzó vezetéknév'
            if (!(/\S+@\S+\.\S+/.test(user.email))) return 'Helytelen email cím'
            if (!test(user.address?.country)) return 'Hiányzó ország'
            if (!test(user.address?.zip)) return 'Hiányzó irányítószám'
            if (!test(user.address?.city)) return 'Hiányzó város'
            if (!test(user.address?.line)) return 'Hiányzó címsor'

            return undefined
        },


        save: async function() {

            // Security
            if (this.loading) return
            this.loading = true


            // Save email
            if (this.originalEmail != user.email) {
                try { await firebase.auth().currentUser?.updateEmail(user.email) }
                catch(error) { alert(error) }
            }
            

            // Save details
            const details = {
                first_name: user.first_name,
                last_name: user.last_name,
                address: user.address
            }
            try { await firebase.firestore().collection('users').doc(user.id).set(details) }
            catch(error) { alert(error) }
            finally { this.loading = false }
        },


        downloadData() {
            firebase.firestore().collection('pledges').where('user_id', '==', user.id).onSnapshot((snap) => {

                // Donations
                let donations: Array<Interface.Pledge> = []
                snap.forEach((doc) => { 
                    let donation = doc.data()
                    delete donation.id
                    donations.push(donation as unknown as Interface.Pledge)
                })


                // User
                const usercopy = JSON.parse(JSON.stringify(user))
                delete usercopy.admin
                delete usercopy.id


                // Prepare
                const obj = {user: usercopy, donations: donations}
                const data = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(obj, undefined, 2))


                // Download
                const element = document.createElement('a') as HTMLAnchorElement
                element.setAttribute('href', data)
                element.setAttribute('download', this.$t('data') + ".txt")
                document.body.appendChild(element)
                element.click()
                element.remove()
            })
        },


        logout: async function() {

            // Validate
            if (this.loading) return
            if (!window.confirm(this.$t('sure_logout'))) return
            this.loading = true


            // Process
            try {
                await firebase.auth().signOut()
                this.$router.push({ name: 'list' })
            }
            catch(error) { alert(error) }
            finally { this.loading = false }
        },


        deleteAccount: async function() {
            
            // Validate
            if (this.loading) return
            if (!window.confirm(this.$t('sure_delete'))) return
            this.loading = true


            // Delete
            try { 
                await firebase.auth().currentUser?.delete()
                this.$router.push({name: 'list'})
            }
            catch(error) { alert(error) }
            finally { this.loading = false }
        },


        openTerms: function() {
            let route = this.$router.resolve({name: 'terms'});
            window.open(route.href, '_blank');
        }
    }
})
